import type { QueryClient } from '@tanstack/react-query';
import type { LoaderFunctionArgs } from 'react-router';

import { ensureNumericId } from '@jane/kiosk/util';

export type CartConfirmationLoaderType = { productId: number };

export const cartConfirmationLoader =
  (_queryClient: QueryClient) =>
  async ({
    params,
  }: LoaderFunctionArgs): Promise<CartConfirmationLoaderType> => {
    const { productId } = params;

    const numericProductId = ensureNumericId(productId);

    return {
      productId: numericProductId,
    };
  };
